import { Stack, Typography, styled, type CSSObject } from '@mui/material';
import { Section } from '@rumblefish/ui/Rumblefish23Theme';
import { Link } from '@rumblefish/ui/Rumblefish23Theme';

export const StyledSection = styled(Section)(() => ({
  position: 'relative',
}));

export const StyledStack = styled(Stack)(({ theme }) => ({
  paddingTop: theme.spacing(12),
  paddingBottom: theme.spacing(12),
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(8),
  [theme.breakpoints.down('md')]: {
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(6),
    gap: theme.spacing(6),
  },
}));

export const StyledHeaderStack = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(3),
  maxWidth: '780px',
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  ...(theme.mixins.neutralGradient as CSSObject),
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  letterSpacing: '-0.02em',
}));

export const StyledIntro = styled(Typography)(({ theme }) => ({
  color: theme.palette.invertedContent?.SECONDARY,
}));

export const StyledCardsWrapper = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  gap: theme.spacing(4),
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}));

export const StyledGrantCard = styled(Stack)(({ theme }) => ({
  flex: 1,
  gap: theme.spacing(2),
  padding: theme.spacing(4),
  border: `1px solid ${theme.palette.greyBackgroundColor?.SURFACE + '20'}`,
  borderRadius: theme.spacing(3),
  background:
    'radial-gradient(47.45% 48.31% at -0.77% 0%, rgba(255, 255, 255, 0.04) 0%, rgba(255, 255, 255, 0) 100%)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(3),
  },
}));

export const StyledGrantBadge = styled(Typography)(({ theme }) => ({
  display: 'inline-block',
  padding: theme.spacing(0.5, 1.5),
  borderRadius: theme.spacing(10),
  border: `1px solid ${'#FFD900' + '60'}`,
  color: '#FFD900',
  fontSize: '13px',
  fontWeight: 600,
  letterSpacing: '0.02em',
  width: 'fit-content',
}));

export const StyledGrantTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.invertedContent?.PRIMARY,
  letterSpacing: '-0.01em',
}));

export const StyledGrantDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.invertedContent?.SECONDARY,
  lineHeight: '160%',
  flex: 1,
}));

export const StyledGrantLink = styled(Link)(({ theme }) => ({
  color: '#FFD900',
  fontSize: '14px',
  fontWeight: 600,
  textDecoration: 'none',
  marginTop: theme.spacing(1),
  '&:hover': {
    textDecoration: 'underline',
  },
}));

export const StyledQuoteWrapper = styled(Stack)(({ theme }) => ({
  borderLeft: `3px solid ${'#FFD900'}`,
  paddingLeft: theme.spacing(4),
  gap: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    paddingLeft: theme.spacing(2),
  },
}));

export const StyledQuoteText = styled(Typography)(({ theme }) => ({
  ...(theme.mixins.neutralGradient as CSSObject),
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  fontStyle: 'italic',
  lineHeight: '160%',
}));

export const StyledQuoteAuthor = styled(Typography)(({ theme }) => ({
  color: theme.palette.invertedContent?.SECONDARY,
}));

export const StyledClosing = styled(Typography)(({ theme }) => ({
  color: theme.palette.invertedContent?.SECONDARY,
  maxWidth: '780px',
}));
